import { ButtonHTMLAttributes, ReactNode } from 'react';
import { classNames } from '@/utils/classNames';
import styles from './IconButton.module.css';

export type IconButtonVariant = 'border' | 'subtle' | 'ghost';

type IconButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: IconButtonVariant;
  icon: ReactNode;
  'aria-label': string;
};

export const IconButton = ({
  variant = 'border',
  icon,
  className,
  type = 'button',
  ...rest
}: IconButtonProps) => (
  <button
    type={type}
    className={classNames(styles.root, styles[variant], className)}
    {...rest}
  >
    <span className={styles.icon} aria-hidden>
      {icon}
    </span>
  </button>
);
